import React, { useEffect, useState } from "react";
import { LeftArrowIcon } from "../../../../assets/icons/svgicons";
import Radio from "../../Formik/Radio/Radio";
import Modal from "../Modal/Modal";
import Button from "../../Button/Button";
import styles from "./PaymentOptionsModal.module.scss";
import { useSelector } from "react-redux";
import { formatPrice, toFix } from "../../../../utils/utils";
import ErrorText from "../../Formik/ErrorText/ErrorText";

const PaymentOptionsModal = ({
  show,
  handleClose,
  paymentMode,
  setPaymentMode,
  handleWalletOptionsModal,
  shippingFee,
}) => {
  const walletBalance = useSelector((state) => state?.users?.walletBalance);
  const [wallets, setWallets] = useState([]);
  const commonBalance = useSelector(
    (state) => state?.users?.commonWalletBalance?.amount
  );

  useEffect(() => {
    setWallets([
      // {
      //   title: "Stripe Wallet",
      //   value: "Stripe",
      //   // text: "Invest large amount",
      //   isDisabled: false,
      //   isChecked: false,
      //   balance:
      //     walletBalance.length > 0 &&
      //     walletBalance?.filter((item) => item.account_type === "STRIPE")[0]
      //       ?.amount,
      // },
      // {
      //     title: "Direct Deposit",
      //     value: "direct",
      //     text: "Invest large amount",
      //     desc: "Use this for basic payments",
      //     isDisabled: true,
      //     isChecked:false,
      // },
      {
        title: "STBL Wallet",
        value: "WIRE",
        // text: "Invest large amount",
        isDisabled: false,
        isChecked: false,
        balance:
          walletBalance.length > 0 &&
          walletBalance?.filter((item) => item.account_type === "WIRE")[0]
            .amount,
      },
    ]);
  }, [walletBalance]);

  return (
    <>
      <Modal
        show={show}
        handleClose={() => {
          handleWalletOptionsModal(true);
          handleClose();
        }}
        className={styles.options_modal}
        title={
          <>
            <span
              onClick={() => {
                handleWalletOptionsModal(true);
                handleClose();
              }}
            >
              <LeftArrowIcon />
              Back
            </span>
          </>
        }
        hideCloseBtn={true}
      >
        <div className={styles.options_modal_body}>
          {wallets?.map((item, index) => (
            <label key={index}>
              <div className={styles.radio}>
                <Radio
                  name="payment_method"
                  value={item.value}
                  disabled={item?.balance < shippingFee}
                  checked={paymentMode === item?.value}
                  onChange={(event) => setPaymentMode(event.target.value)}
                />
              </div>
              <div>
                <h4>{item.title}</h4>
                <p>{item.text}</p>
                <h5>
                  Bal: <span>${toFix(Number(commonBalance), 3)}</span>
                </h5>
                {item?.balance < shippingFee && (
                  <ErrorText>
                    Low Funds. Please add more funds in order to proceed.
                  </ErrorText>
                )}
              </div>
            </label>
          ))}
          <Button
            fluid
            className={styles.submit_btn}
            onClick={() => {
              handleWalletOptionsModal(true);
              handleClose();
            }}
          >
            Confirm
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default PaymentOptionsModal;
